export const ACTION = '/Catalog/Products';
